var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ItemModalService } from './item-modal.service';
var ItemModalComponent = /** @class */ (function (_super) {
    __extends(ItemModalComponent, _super);
    function ItemModalComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.modalSubmit = new EventEmitter();
        _this.type = [];
        _this.category = [];
        _this.row = {};
        _this.service.initQuery();
        return _this;
    }
    ItemModalComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ItemModalComponent.prototype.ngAfterViewInit = function () {
        this.modal = this.remodalElement.nativeElement;
    };
    ItemModalComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ItemModalComponent.prototype.onSubscribe = function (data) {
        var _this = this;
        this.service.getItemType().subscribe(function (rec) {
            if (rec instanceof Array) {
                _this.type = rec;
            }
        });
        // this.service.getItemCategory().subscribe(rec => {
        // 	if (rec instanceof Array) {
        // 		this.category = rec;
        // 	}
        // });
    };
    ItemModalComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#open') {
            this.service.initQuery();
            this.service.getList();
            this.remodal = $(this.modal).remodal({ hashTracking: false });
            this.remodal.open();
        }
    };
    ItemModalComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'row') {
            this.row = rec;
        }
    };
    ItemModalComponent.prototype.onSubmit = function () {
        this.modalSubmit.emit(this.row);
        this.remodal.close();
    };
    ItemModalComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    ItemModalComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'item-modal',
                    template: "<!-- remodal -->\n<div class=\"remodal\" id=\"{{ componentName + '#Remodal#item' }}\" #remodal>\n  <div class=\"remodal_whitebg\">\n    <item-modal-search [componentName]=\"componentName + '#search'\" [component]=\"{name: componentName + '#search'}\" [type]=\"type\" [category]=\"category\"></item-modal-search>\n    <div class=\"row -my-3\">\n      <div class=\"col-sm-6\">\n        <item-modal-listcount [componentName]=\"componentName + '#listcount'\" [component]=\"{name: componentName + '#listcount'}\"></item-modal-listcount>\n      </div>\n      <div class=\"col-sm-6 -txtalnright\">\n        <item-modal-rows [componentName]=\"componentName + '#rows'\" [component]=\"{name: componentName + '#rows', params: component.params}\"></item-modal-rows>\n      </div>\n    </div>\n    <div class=\"row -my-3\">\n      <div class=\"col-sm-12\">\n        <item-modal-list [componentName]=\"componentName + '#list'\" [component]=\"{name: componentName + '#list'}\" [type]=\"type\" [category]=\"category\" (clickRow)=\"onEvent('', 'row', $event)\"></item-modal-list>\n      </div>\n    </div>\n    <div class=\"row -mt-3 -mx-3\">\n      <div class=\"col-sm-12\">\n        <item-modal-pager [componentName]=\"componentName + '#pager'\" [component]=\"{name: componentName + '#pager', params: component.params}\"></item-modal-pager>\n      </div>\n    </div>\n  </div>\n  <div class=\"remodal_btns\">\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"onSubmit()\">{{ (msg | async)['ItemModalComponent.button.complete'] }}</button>\n      </li>\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\">{{ (msg | async)['ItemModalComponent.button.cancel'] }}</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    ItemModalComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ItemModalService }
    ]; };
    ItemModalComponent.propDecorators = {
        modalSubmit: [{ type: Output }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }]
    };
    return ItemModalComponent;
}(ContentBaseComponent));
export { ItemModalComponent };
//# sourceMappingURL=item-modal.component.js.map